import React from "react";
import ThankYou from "../../components/ThankYou";

export default function RAFthAttorney() {
  return (
    <div>
      <ThankYou />
    </div>
  );
}
